import {setUserId as amplitudeSetUserId} from '@amplitude/analytics-browser'
import logger from '@helpers/logger'

export function setUserId(userId) {
  try {
    amplitudeSetUserId(userId)
  } catch (error) {
    logger.error('Failed Amplitude setUserId', {error})
  }
}
